










import { Component, Vue } from "vue-property-decorator";
import GlobalAlerts from "@/components/GlobalAlerts.vue";
@Component({
  components: { GlobalAlerts },
})
export default class AuthLayout extends Vue {}
